import {
  IProductPricingStore,
  ProductPricingStore
} from '@atlassian/bxp-product-pricing';
import {
  ICCPProductCatalogClient,
  IProductCatalogClient
} from '@atlassiansox/asc-product-catalog';
import React, { createContext, ReactChild, useContext } from 'react';

const notProvided = async () => {
  throw new Error(
    'ProductPricingStore was not provided. Use <ProductPricingStoreProvider />'
  );
};

export const ProductPricingStoreContext = createContext<IProductPricingStore>({
  getPricingPlans: notProvided,
  getProducts: notProvided,
  searchAddons: notProvided,
  getOfferings: notProvided
});

export function useProductPricingStore(): IProductPricingStore {
  return useContext(ProductPricingStoreContext);
}

export type ProductPricingStoreProviderProps = {
  readonly productCatalogClient: IProductCatalogClient;
  readonly ccpProductCatalogClient: ICCPProductCatalogClient;
  readonly children: ReactChild;
};

export function ProductPricingStoreProvider({
  productCatalogClient,
  ccpProductCatalogClient,
  children
}: ProductPricingStoreProviderProps) {
  return (
    <ProductPricingStoreContext.Provider
      value={
        new ProductPricingStore({
          productCatalogClient,
          ccpProductCatalogClient
        })
      }
    >
      {children}
    </ProductPricingStoreContext.Provider>
  );
}
